import React, { useState } from 'react';
import { App } from 'antd';

import { createFormData } from '../../../../../utils/common/createFormData';
import { MassBroadcastsForm } from '../components/MassBroadcastsForm';
import { initialValues } from '../utils/form';
import { MassBroadCastDTO } from '../service/broadcasts.interface';
import {
    broadcastSegmentation,
    broadcastStatus,
    sendBroadcastsType,
} from '../utils/options';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../../../shops/features/shops/store/shopSlice';
import { useApiErrorNotification } from '../../../../../hooks/useApiErrorNotification';
import { useApiSuccessNotification } from '../../../../../hooks/useApiSuccessNotification';
import {
    useCreateSendToListBroadcastMutation,
    useCreateSendToVisitorsBroadcastMutation,
} from '../service/broadcasts.api';

export const MassBroadcastsCreate = () => {
    const current = useAppSelector(selectShopCurrent);

    const { notification } = App.useApp();
    const [segmentationType, setSegmentationType] = useState(null);

    const queryHook = (type: broadcastSegmentation) => {
        switch (type) {
            case broadcastSegmentation.list:
                return useCreateSendToListBroadcastMutation();
            case broadcastSegmentation.visitors:
            default:
                return useCreateSendToVisitorsBroadcastMutation();
        }
    };

    const [createBroadcast, { isSuccess, isLoading, error, isError }] =
        queryHook(segmentationType);

    useApiErrorNotification(isError, error);
    useApiSuccessNotification(
        isSuccess,
        { message: 'Рассылка успешно создана' },
        null,
        true
    );

    const onSave = async (values: MassBroadCastDTO) => {
        if (values.title === '') {
            return notification.error({
                message: 'Нужно указать название рассылки',
            });
        }
        if (values.title.length > 100) {
            return notification.error({
                message: 'Название рассылки не может быть длиннее 100 символов',
            });
        }

        if (
            values.segmentation === broadcastSegmentation.list &&
            !values.chat_ids
        ) {
            return notification.error({
                message:
                    'Нужно загрузить файл со списком пользователей магазина для рассылки',
            });
        }

        if (!values.text) {
            return notification.error({
                message: values.image
                    ? 'Для рассылок с изображением обязательно заполнять "Заголовок"'
                    : 'Для рассылок без изображений обязательно заполнять "Сообщение рассылки"',
            });
        }

        const data: MassBroadCastDTO = {
            ...values,
            title: values.title,
            segmentation: values.segmentation,
            send_at: values.send_at,
            status: broadcastStatus.planned,
            type: values.image
                ? sendBroadcastsType.promo
                : sendBroadcastsType.text,
        };

        const filteredLinksArray = values.linksArray.filter(
            item => item.linkKey !== '' && item.linkValue !== ''
        );

        if (filteredLinksArray.length > 0) {
            const linksObject = values.linksArray.reduce(
                (accumulator, current) => {
                    accumulator[current.linkKey] = current.linkValue;
                    return accumulator;
                },
                {}
            );
            data.links = JSON.stringify(linksObject);
        }

        if (values.segmentation === broadcastSegmentation.list) {
            data.chat_ids = values.chat_ids[0]?.originFileObj;
        }

        if (values.image) {
            data.image = values.image;
            data.caption = values.text;
        } else {
            data.message = values.text;
        }

        await createBroadcast({
            shop_id: current.id,
            body: createFormData(data),
        });
    };

    return (
        <MassBroadcastsForm
            initialValues={initialValues}
            onSave={onSave}
            loading={isLoading}
            setSegmentationType={setSegmentationType}
        />
    );
};
